export default __webpack_public_path__ + "static/media/Google__G__Logo.svg.f75dc7bb.png";